export default __webpack_public_path__ + "static/media/small_head_-2.0b38d7d4.webp";